import { Directive, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchBlockContentStrategy } from 'src/app/components/map/search-block/strategy/search-block-content.strategy';
import { unsubscribeAll } from '../../../../common/app.helpers';
import { FieldAttribute, SelectorOption } from '../../../../interfaces/form-and-field.interface';
import { MapSearchBlockContent } from '../../../../interfaces/map.interface';
import { NestedBucketIndividualRole } from '../../map.enum';
import { SearchBlockFieldValues } from '../../map.interfaces';
import { MapValues } from '../../map.values';

@Directive()
export class PeopleSearchBlockContentStrategy extends SearchBlockContentStrategy implements OnDestroy {
  private searchBlockFieldValues: SearchBlockFieldValues;

  public constructor(
    private roleSuggestions: SelectorOption[],
    mapSearchBlockContent: MapSearchBlockContent,
    public searchBlockFieldObservable: Observable<SearchBlockFieldValues>,
  ) {
    super(mapSearchBlockContent);
    this.initValues();
  }

  public initValues(): void {
    this.subscribeToSearchBlockFieldChanges();
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions);
  }

  public emitSearchFormContent(): void {
    const [disableDiseases, disableSpecialities] = this.checkRolesSelected();
    this.updateFieldsVisibility({
      diseases: { disabled: disableDiseases },
      specialties: { disabled: disableSpecialities },
      charity_focuses: { hidden: true, disabled: true },
    });
    this.updateRoleFieldSuggestions();
  }

  public checkRolesSelected(): boolean[] {
    const searchBlockFieldValues: SearchBlockFieldValues = this.searchBlockFieldValues;
    return [
      searchBlockFieldValues.roles
        .map((i: SelectorOption) => i.entity_id)
        .includes(NestedBucketIndividualRole.MED_STAFF),
      searchBlockFieldValues.roles.map((i: SelectorOption) => i.entity_id).includes(NestedBucketIndividualRole.PATIENT),
    ];
  }

  private subscribeToSearchBlockFieldChanges(): void {
    this.subscriptions.push(
      this.searchBlockFieldObservable.subscribe((searchBlockFieldValues: SearchBlockFieldValues) => {
        this.searchBlockFieldValues = searchBlockFieldValues;
        this.emitSearchFormContent();
      }),
    );
  }

  private updateRoleFieldSuggestions(): void {
    const searchBlockFieldValues: SearchBlockFieldValues = this.searchBlockFieldValues;
    const attrs: FieldAttribute[] = this.fieldAttributes;
    const rolesFieldIndex: number = this.getFieldIndex(MapValues.rolesFieldName);

    attrs[rolesFieldIndex].options = structuredClone(this.roleSuggestions);
    if (searchBlockFieldValues.diseases.length > 0) {
      attrs[rolesFieldIndex].options = attrs[rolesFieldIndex].options.filter(
        (option: SelectorOption) => option.entity_id !== NestedBucketIndividualRole.MED_STAFF,
      );
    }
    if (searchBlockFieldValues.specialties.length > 0) {
      attrs[rolesFieldIndex].options = attrs[rolesFieldIndex].options.filter(
        (option: SelectorOption) => option.entity_id !== NestedBucketIndividualRole.PATIENT,
      );
    }
  }
}
